/**
 * A–Z ordering for user pickers. No user-list endpoint sorts, so dropdowns otherwise list users in the order they
 * were added. Each picker sorts by the label it DISPLAYS (email in most, a name in a few), so the list reads A–Z
 * exactly as it looks.
 *
 * Standalone (imports nothing from the `utils` barrel, which contains JSX) so vitest can import it.
 */
const isBlank = (label) => label === null || label === undefined || String(label).trim() === "";

/** Case- and accent-insensitive, numeric-aware ("user2" before "user10"); blank labels sort last. */
export const compareLabels = (a, b) => {
  if (isBlank(a)) return isBlank(b) ? 0 : 1;
  if (isBlank(b)) return -1;
  return String(a).localeCompare(String(b), undefined, { sensitivity: "base", numeric: true });
};

/**
 * A sorted COPY of `items`, ordered by `labelOf(item)`. Never sorts in place: the input is usually React Query
 * cache data, and an in-place sort would reorder it for every other consumer too. Accepts any iterable (one
 * endpoint returns a Set) and treats a missing list as empty.
 */
export const sortByLabel = (items, labelOf) =>
  Array.from(items ?? []).sort((a, b) => compareLabels(labelOf(a), labelOf(b)));

/** The common case: users listed by email. */
export const sortUsersByEmail = (users) => sortByLabel(users, (user) => user?.email);
